import React from 'react';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';
import Icon from '../../../components/AppIcon';

const CharacterCreationStep = ({ formData, errors, onChange, onSelectChange }) => {
  const classOptions = [
    { value: 'warrior', label: 'Warrior' },
    { value: 'cleric', label: 'Cleric' },
    { value: 'paladin', label: 'Paladin' },
    { value: 'ranger', label: 'Ranger' },
    { value: 'shadowknight', label: 'Shadow Knight' },
    { value: 'druid', label: 'Druid' },
    { value: 'monk', label: 'Monk' },
    { value: 'bard', label: 'Bard' },
    { value: 'rogue', label: 'Rogue' },
    { value: 'shaman', label: 'Shaman' },
    { value: 'necromancer', label: 'Necromancer' },
    { value: 'wizard', label: 'Wizard' },
    { value: 'magician', label: 'Magician' },
    { value: 'enchanter', label: 'Enchanter' },
    { value: 'beastlord', label: 'Beastlord' },
    { value: 'berserker', label: 'Berserker' }
  ];

  const serverOptions = [
    { value: 'firiona-vie', label: 'Firiona Vie' },
    { value: 'antonius-bayle', label: 'Antonius Bayle' },
    { value: 'bristlebane', label: 'Bristlebane' },
    { value: 'cazic-thule', label: 'Cazic-Thule' },
    { value: 'drinal', label: 'Drinal' },
    { value: 'erollisi-marr', label: 'Erollisi Marr' },
    { value: 'povar', label: 'Povar' },
    { value: 'the-rathe', label: 'The Rathe' },
    { value: 'tunare', label: 'Tunare' },
    { value: 'xegony', label: 'Xegony' }
  ];

  return (
    <div className="space-y-4 md:space-y-5 lg:space-y-6">
      <div className="bg-card rounded-xl p-4 md:p-5 lg:p-6 border border-border">
        <div className="flex items-start gap-3 mb-4">
          <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
            <Icon name="Swords" size={20} color="var(--color-primary)" />
          </div>
          <div>
            <h3 className="text-lg md:text-xl lg:text-2xl font-semibold text-foreground mb-1">
              Create Your First Character
            </h3>
            <p className="text-sm md:text-base text-muted-foreground">
              Add your main character to start tracking progression
            </p>
          </div>
        </div>

        <div className="space-y-4 md:space-y-5">
          <Input
            label="Character Name"
            type="text"
            name="characterName"
            placeholder="Enter your character's name"
            value={formData?.characterName}
            onChange={onChange}
            error={errors?.characterName}
            required
            description="Your in-game character name"
          />

          <Select
            label="Character Class"
            placeholder="Select your class"
            options={classOptions}
            value={formData?.characterClass}
            onChange={(value) => onSelectChange('characterClass', value)}
            error={errors?.characterClass}
            required
            searchable
            description="Choose your character's class"
          />

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
            <Input
              label="Current Level"
              type="number"
              name="characterLevel"
              placeholder="1-75"
              value={formData?.characterLevel}
              onChange={onChange}
              error={errors?.characterLevel}
              required
              min="1"
              max="75"
              description="Your character's current level"
            />

            <Select
              label="Server"
              placeholder="Select server"
              options={serverOptions}
              value={formData?.server}
              onChange={(value) => onSelectChange('server', value)}
              error={errors?.server}
              required
              searchable
              description="Your game server"
            />
          </div>
        </div>
      </div>
      <div className="bg-accent/10 rounded-xl p-4 md:p-5 border border-accent/20">
        <div className="flex items-start gap-3">
          <Icon name="Info" size={20} color="var(--color-accent)" className="flex-shrink-0 mt-0.5" />
          <div className="text-sm md:text-base">
            <p className="font-medium text-foreground mb-2">Character Management</p>
            <ul className="space-y-1.5 text-muted-foreground">
              <li className="flex items-start gap-2">
                <Icon name="Check" size={14} color="var(--color-success)" className="flex-shrink-0 mt-1" />
                <span>You can add multiple characters after registration</span>
              </li>
              <li className="flex items-start gap-2">
                <Icon name="Check" size={14} color="var(--color-success)" className="flex-shrink-0 mt-1" />
                <span>Switch between characters easily from the dashboard</span>
              </li>
              <li className="flex items-start gap-2">
                <Icon name="Check" size={14} color="var(--color-success)" className="flex-shrink-0 mt-1" />
                <span>Track individual progression for each character</span>
              </li>
              <li className="flex items-start gap-2">
                <Icon name="Check" size={14} color="var(--color-success)" className="flex-shrink-0 mt-1" />
                <span>Update character information anytime</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="bg-success/10 rounded-xl p-4 md:p-5 border border-success/20">
        <div className="flex items-start gap-3">
          <Icon name="Trophy" size={20} color="var(--color-success)" className="flex-shrink-0 mt-0.5" />
          <div className="text-sm md:text-base">
            <p className="font-medium text-foreground mb-1">Ready to Adventure!</p>
            <p className="text-muted-foreground">
              Once you complete registration, you'll have access to guild announcements, 
              expansion progression tracking, and the full member directory.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CharacterCreationStep;